import { render, staticRenderFns } from "./paymentAdequacy6MonthsFollowUp.vue?vue&type=template&id=dc0e2e00"
import script from "./paymentAdequacy6MonthsFollowUp.vue?vue&type=script&lang=js"
export * from "./paymentAdequacy6MonthsFollowUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports